// vzhlad_predajne_v2 (20. 10. 2026, ústava 61.10): starý oranžový panel/akcent nahradený hodnotami témy — 1 miest
// ObhliadkaEditor — PLNÝ editor obhliadky v pravom stĺpci desktopu (Mirko 27.7.):
// „aj obhliadky majú mať pravý stĺpec ako CP — horná časť DOPYT a KONTAKT (zákazník, adresa,
//  telefón, e-mail, GPS, dátumy), spodná časť ten istý štýl polí, vizuálne oddelená" +
// „obhliadka sa dá teoreticky vytvoriť aj po telefóne — desktop musí obsahovať VŠETKY
//  náležitosti ako mview a tiež sa musí dať rozdeliť potery a omietky".
// Panel = zdieľané DocFields (ústava 103.D); číselníky = lib/obhliadka_polia.js (zdieľané s mview).
import { setDirty as setGuardDirty } from '../hooks/unsavedGuard.js'   // p95 — doklad = obrazovka (ústava 67.15)
import { KontaktnaOsoba } from '../components/KontaktyPartnera.jsx'   // ústava 131.10 + 0.J — jeden blok kontaktnej osoby (p93)
import React, { useState, useEffect } from 'react'
import TelefonInput from '../components/TelefonInput.jsx'
import { COLORS, TYPO, SPACE, RADIUS } from '../theme.js'
import { Field, FieldGrid, inp } from '../components/DocFields.jsx'
import { SearchableSelect } from '../components/Ui.jsx'
import { Btn, BtnAdd, BtnGhost } from '../components/Btn.jsx'
import NoviCustomerDialog from '../components/NoviCustomerDialog.jsx'
import { fetchAuth } from '../auth/fetchAuth.js'
import { useToast } from '../components/Toast.jsx'
import { normPhone } from '../utils/phone.js'
import { INFORMUJ, POTER_INFORMUJ, POTER_CHECKLIST, OPT } from '../lib/obhliadka_polia.js'
import VyskyStavba from './VyskyStavba.jsx'   // VYSKY_V1 (4. 11. 2026): Meranie výšky podlahy pri obhliadke s potermi (zákazka ešte nie je)

const J = (s, d) => { try { const v = JSON.parse(s); return v == null ? d : v } catch (_) { return d } }

function fromRecord(r) {
  return {
    typ: r.typ === 'poter' ? 'poter' : 'omietky',
    nazov_dopytu: r.nazov_dopytu || '', customer_id: r.customer_id || '', kontakt_meno: r.kontakt_meno || '',
    telefon: r.telefon || '', email: r.email || '', email2: r.email2 || '', adresa: r.adresa || '',
    gps_lat: r.gps_lat || '', gps_lng: r.gps_lng || '', maps_link: r.maps_link || '',
    datum_obhliadky: (r.datum_obhliadky || '').slice(0, 10), termin_real: r.termin_real || '',
    termin_partia: r.termin_partia || '', cakacia: !!r.cakacia,
    druh_nehnutelnosti: r.druh_nehnutelnosti || '', druh_popis: r.druh_popis || '',
    stav_objektu: r.stav_objektu || '', murivo: r.murivo || '', murivo_popis: r.murivo_popis || '',
    realizacia: r.realizacia || '', druh_omietky: r.druh_omietky || '', omietka_popis: r.omietka_popis || '',
    vymera_podorys: r.vymera_podorys || '', vymera_omietky: r.vymera_omietky || '',
    stropy: !!r.stropy, stropy_priplatok: r.stropy_priplatok || '', sietka: !!r.sietka, sietka_cena: r.sietka_cena || '',
    poter_material: r.poter_material || '', poter_material_kod: r.poter_material_kod || '',
    poter_podlazia: J(r.poter_podlazia_json, []), poter_checklist: J(r.poter_checklist_json, []),
    voda: r.voda || '', elektrika: r.elektrika || '', elektrika_popis: r.elektrika_popis || '',
    pristup: r.pristup || '', pristup_popis: r.pristup_popis || '', prijazd_nakladiak: !!r.prijazd_nakladiak,
    sluzby: { potery: false, potery_popis: '', zateplenie: false, malovanie: false, ine: false, ine_popis: '', ...J(r.sluzby_json, {}) },
    cena_m2: r.cena_m2 || '', material_kg: r.material_kg || '',
    cena_materialu: r.cena_materialu || '', cena_prace: r.cena_prace || '', priplatok_palivo: r.priplatok_palivo || '',
    informoval: J(r.informoval_json, []), poznamka: r.poznamka || '', obhliadku_robil: r.obhliadku_robil || '',
    foto: J(r.foto_json, []), stav: r.stav || 'dopyt',
  }
}

function compressPhoto(file) { return new Promise(res => { try {
  const img = new Image(); const u = URL.createObjectURL(file)
  img.onload = () => { try { const MAX = 1600; let w = img.width, h = img.height; const r = Math.min(1, MAX / Math.max(w, h)); w = Math.round(w * r); h = Math.round(h * r)
    const c = document.createElement('canvas'); c.width = w; c.height = h; c.getContext('2d').drawImage(img, 0, 0, w, h)
    c.toBlob(b => { URL.revokeObjectURL(u); res(b && b.size < file.size ? b : file) }, 'image/jpeg', 0.82)
  } catch (e) { URL.revokeObjectURL(u); res(file) } }
  img.onerror = () => { URL.revokeObjectURL(u); res(file) }; img.src = u
} catch (e) { res(file) } }) }

// Chips/YesNo v desktop štýle (rovnaké hodnoty ako mview, vzhľad panela dokladov)
function Chips({ opts, val, onPick }) {
  return <div style={{ display: 'flex', gap: 5, flexWrap: 'wrap' }}>
    {opts.map(o => { const on = val === o; return (
      <button key={o} type="button" onClick={() => onPick(on ? '' : o)} style={{
        padding: '5px 11px', borderRadius: RADIUS.full, fontSize: TYPO.sizes.sm, cursor: 'pointer', fontFamily: 'inherit',
        border: `1px solid ${on ? COLORS.brand : COLORS.line}`, background: on ? COLORS.brand : '#fff', color: on ? '#fff' : COLORS.text,
      }}>{o}</button>) })}
  </div>
}
function YesNo({ label, val, onChange }) {
  return <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, padding: '4px 0' }}>
    <span style={{ fontSize: TYPO.sizes.sm }}>{label}</span>
    <div style={{ display: 'flex', gap: 4 }}>
      {[['áno', true], ['nie', false]].map(([t, v]) => { const on = val === v; return (
        <button key={t} type="button" onClick={() => onChange(v)} style={{ padding: '3px 13px', borderRadius: RADIUS.full, fontSize: TYPO.sizes.xs, cursor: 'pointer', fontFamily: 'inherit',
          border: `1px solid ${on ? COLORS.brand : COLORS.line}`, background: on ? COLORS.brand : '#fff', color: on ? '#fff' : COLORS.muted }}>{t}</button>) })}
    </div>
  </div>
}
function Grp({ children }) {
  return <div style={{ fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.bold, color: COLORS.brand, textTransform: 'uppercase', letterSpacing: '0.04em', margin: '14px 0 6px', borderBottom: `1px solid ${COLORS.lineSoft || COLORS.line}`, paddingBottom: 3 }}>{children}</div>
}

export default function ObhliadkaEditor({ record, onSaved }) {
  const toast = useToast()
  const [f, setF] = useState(() => fromRecord(record))
  const [dirty, setDirty] = useState(false)
  const [saving, setSaving] = useState(false)
  const [customers, setCustomers] = useState([])
  const [novyOpen, setNovyOpen] = useState(false)
  const [novyPrefill, setNovyPrefill] = useState('')
  const [freeWeeks, setFreeWeeks] = useState(null)
  const [freeLoading, setFreeLoading] = useState(false)
  // MIXIN katalog poterov — JEDEN zdroj = Poter protokol (/api/poter-protokoly/meta), nie kopia (Mirko 27.7.)
  const [mixin, setMixin] = useState({ anhydrit: [], cement: [] })

  useEffect(() => { setF(fromRecord(record)); setDirty(false); setFreeWeeks(null) }, [record.id])  // eslint-disable-line
  useEffect(() => { fetchAuth('/api/customers').then(r => r.ok ? r.json() : []).then(d => setCustomers(Array.isArray(d) ? d : [])).catch(() => {}) }, [])
  useEffect(() => { fetchAuth('/api/poter-protokoly/meta').then(r => r.ok ? r.json() : null).then(d => { if (d && d.materials) setMixin(d.materials) }).catch(() => {}) }, [])

  const set = (k, v) => { setF(s => ({ ...s, [k]: v })); setDirty(true) }
  const setSluzba = (k, v) => { setF(s => ({ ...s, sluzby: { ...s.sluzby, [k]: v } })); setDirty(true) }
  const toggleInf = (t) => set('informoval', f.informoval.includes(t) ? f.informoval.filter(x => x !== t) : [...f.informoval, t])
  const togglePC = (k) => set('poter_checklist', f.poter_checklist.includes(k) ? f.poter_checklist.filter(x => x !== k) : [...f.poter_checklist, k])
  const addPodl = () => set('poter_podlazia', [...f.poter_podlazia, { miestnost: '', plocha_m2: '', hrubka_mm: '', vagrys: '', vyska_od_vagrysu: '', vyska2: '', vyska2_popis: '' }])
  const setPodl = (i, k, v) => set('poter_podlazia', f.poter_podlazia.map((p, idx) => idx === i ? { ...p, [k]: v } : p))
  const delPodl = (i) => set('poter_podlazia', f.poter_podlazia.filter((_, idx) => idx !== i))

  // Kontakt z karty partnera — doplní LEN prázdne polia (nedeštruktívne, ústava 103.D)
  const pickCustomer = (id) => {
    const c = customers.find(x => x.id === id)
    setF(s => ({ ...s, customer_id: id,
      kontakt_meno: s.kontakt_meno || (c && c.name) || '',
      telefon: s.telefon || (c && c.phone) || '', email: s.email || (c && c.email) || '',
      email2: s.email2 || (c && c.email2) || '', adresa: s.adresa || (c && c.address) || '' }))
    setDirty(true)
  }

  const omietkaTyp = () => { const d = (f.druh_omietky || '').toLowerCase()
    if (d.includes('sadr') || d.includes('klima')) return 'sadrova'
    if (d.includes('cement') || d.includes('jadr')) return 'cementova'
    return '' }
  const fmtSk = (s) => { const p = String(s).split('-'); return p.length === 3 ? `${p[2]}.${p[1]}.` : s }
  const fetchFree = async () => {
    setFreeLoading(true); setFreeWeeks(null)
    try { const r = await fetchAuth('/api/obhliadky/free-partie?weeks=8&omietka=' + omietkaTyp()); const d = await r.json(); setFreeWeeks(d.weeks || []) }
    catch (_) { toast.error('Voľné partie sa nenačítali') } finally { setFreeLoading(false) }
  }
  const pickWeek = (wk, p) => { set('termin_real', `Tý ${fmtSk(wk.start)}–${fmtSk(wk.end)}${String(wk.end).slice(0, 4)} · ${p.name}`); set('termin_partia', p.id); set('cakacia', false) }

  const uploadFoto = async (files) => {
    for (const file of files) {
      try {
        const small = await compressPhoto(file)
        const fd = new FormData(); fd.append('file', small, 'foto.jpg')
        const r = await fetchAuth('/api/obhliadky/upload-photo', { method: 'POST', body: fd })
        const j = await r.json()
        if (j.url) set('foto', [...f.foto, j.url]); else toast.error(j.error || 'Fotka sa nenahrala')
      } catch (_) { toast.error('Fotka sa nenahrala') }
    }
  }

  const save = async () => {
    if (!f.nazov_dopytu.trim()) { toast.error('Zadaj názov dopytu.'); return false }
    setSaving(true)
    try {
      const body = { ...f, telefon: normPhone(f.telefon) }
      const r = await fetchAuth('/api/obhliadky/' + record.id, { method: 'PUT', body: JSON.stringify(body) })
      if (!r.ok) { const d = await r.json().catch(() => ({})); throw new Error(d.error || 'HTTP ' + r.status) }
      toast.success('Obhliadka uložená.')
      setDirty(false)
      onSaved && onSaved()
      return true
    } catch (e) { toast.error('Nepodarilo sa uložiť: ' + e.message); return false }
    finally { setSaving(false) }
  }
  // p95: obhliadka sa hlási do spoločného registra neuložených zmien — okno Odoslať, PDF a prechod na inú obhliadku
  // ju najprv uložia (ústava 67.15)
  useEffect(() => {
    const k = 'obhliadka:' + record.id
    setGuardDirty(k, dirty, save)
    return () => setGuardDirty(k, false)
  })

  const mapsHref = f.maps_link || (f.gps_lat ? `https://maps.google.com/?q=${f.gps_lat},${f.gps_lng}` : '')
  const isPoter = f.typ === 'poter'

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.md }}>
      {/* ── HORNÁ ČASŤ: DOPYT A KONTAKT — vizuálne oddelená (tónovaná karta) ── */}
      <div style={{ background: COLORS.bgSoft, border: `1px solid ${COLORS.line}`, borderLeft: `4px solid ${COLORS.brand}`, borderRadius: RADIUS.md, padding: SPACE.md }}>
        <div style={{ fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.bold, color: COLORS.brand, textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: SPACE.sm }}>Dopyt a kontakt</div>
        <FieldGrid>
          <Field label="Názov dopytu *">
            <input style={inp} value={f.nazov_dopytu} onChange={e => set('nazov_dopytu', e.target.value)} placeholder="napr. BD Tatra Svidník" />
          </Field>
          <Field label="Zákazník (číselník)">
            <div style={{ display: 'flex', gap: 6 }}>
              <div style={{ flex: 1, minWidth: 0 }}>
                <SearchableSelect value={f.customer_id || ''} menuPortal allowCreate
                  onChange={v => { const ex = customers.some(c => c.id === v); if (ex) pickCustomer(v); else if (v && v.trim()) { setNovyPrefill(v.trim()); setNovyOpen(true) } else set('customer_id', '') }}
                  options={customers.map(c => ({ value: c.id, label: `${c.name}${c.ico ? ' · IČO ' + c.ico : ''} (${c.id})` }))}
                  placeholder="Hľadať podľa mena alebo IČO…" />
              </div>
              <button type="button" onClick={() => { setNovyPrefill(f.kontakt_meno || ''); setNovyOpen(true) }}
                style={{ padding: '0 12px', border: `1px solid ${COLORS.line}`, background: COLORS.bg, color: COLORS.brand, borderRadius: RADIUS.sm, cursor: 'pointer', fontWeight: TYPO.weights.semibold, fontSize: TYPO.sizes.sm, fontFamily: 'inherit', whiteSpace: 'nowrap' }}>+ Nový</button>
            </div>
          </Field>
          {/* ústava 131.10 + 0.J (p93): JEDEN blok kontaktnej osoby v celom Matrixe — osoba z registra partnera */}
          <KontaktnaOsoba customerId={f.customer_id} inp={inp}
            osoba={{ meno: f.kontakt_meno, telefon: f.telefon, email: f.email }}
            onZmena={o => { set('kontakt_meno', o.meno); set('telefon', o.telefon); set('email', o.email) }}
            obal={(tx, pole, kl) => <Field key={kl} label={tx}>{pole}</Field>} />
          <Field label="E-mail 2 (kópia)">
            <input style={inp} type="email" value={f.email2} onChange={e => set('email2', e.target.value)} placeholder="napr. druhý kontakt na stavbe" />
          </Field>
          <Field label="Adresa stavby">
            <input style={inp} value={f.adresa} onChange={e => set('adresa', e.target.value)} placeholder="ulica, mesto" />
          </Field>
          <Field label="GPS (lat, lng)">
            <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
              <input style={{ ...inp, width: 0, flex: 1 }} value={f.gps_lat} onChange={e => set('gps_lat', e.target.value)} placeholder="49.00" />
              <input style={{ ...inp, width: 0, flex: 1 }} value={f.gps_lng} onChange={e => set('gps_lng', e.target.value)} placeholder="21.24" />
              {mapsHref && <a href={mapsHref} target="_blank" rel="noreferrer" style={{ fontSize: TYPO.sizes.xs, color: COLORS.nav, whiteSpace: 'nowrap' }}>mapa →</a>}
            </div>
          </Field>
          <Field label="Google Maps link (voliteľné)">
            <input style={inp} value={f.maps_link} onChange={e => set('maps_link', e.target.value)} placeholder="vlož zdieľaný pin" />
          </Field>
          <Field label="Dátum obhliadky">
            <input style={inp} type="date" value={f.datum_obhliadky} onChange={e => set('datum_obhliadky', e.target.value)} />
          </Field>
          <Field label="Termín realizácie">
            <input style={inp} value={f.termin_real} onChange={e => { set('termin_real', e.target.value); set('termin_partia', '') }} placeholder="napr. 08/2026" />
          </Field>
          <Field label="Obhliadku robil">
            <Chips opts={OPT.robil} val={OPT.robil.slice(0, 3).includes(f.obhliadku_robil) ? f.obhliadku_robil : (f.obhliadku_robil ? 'Iný' : '')} onPick={v => set('obhliadku_robil', v)} />
            {(f.obhliadku_robil === 'Iný' || (f.obhliadku_robil && !OPT.robil.includes(f.obhliadku_robil))) && (
              <input style={{ ...inp, marginTop: 5 }} value={f.obhliadku_robil === 'Iný' ? '' : f.obhliadku_robil}
                onChange={e => set('obhliadku_robil', e.target.value || 'Iný')} placeholder="Meno a priezvisko" />
            )}
          </Field>
        </FieldGrid>
        <div style={{ display: 'flex', gap: SPACE.md, alignItems: 'center', marginTop: SPACE.sm, flexWrap: 'wrap' }}>
          <Btn variant="nav" onClick={fetchFree} disabled={freeLoading}>{freeLoading ? 'Hľadám…' : 'Ponúkni voľné partie (z Rozpisu)'}</Btn>
          <div style={{ minWidth: 220 }}><YesNo label="Čakacia listina (keď niekto vypadne)" val={f.cakacia} onChange={v => set('cakacia', v)} /></div>
        </div>
        {freeWeeks && freeWeeks.length === 0 && <div style={{ fontSize: TYPO.sizes.sm, color: COLORS.muted, marginTop: 6 }}>Žiadne voľné okno — zadaj vlastný termín alebo čakaciu listinu.</div>}
        {freeWeeks && freeWeeks.length > 0 && (
          <div style={{ marginTop: 8, display: 'flex', flexDirection: 'column', gap: 6 }}>
            {freeWeeks.map(wk => (
              <div key={wk.start} style={{ border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md, padding: 8, background: '#fff' }}>
                <div style={{ fontSize: TYPO.sizes.sm, fontWeight: TYPO.weights.semibold, marginBottom: 5 }}>Týždeň {fmtSk(wk.start)}–{fmtSk(wk.end)}{String(wk.end).slice(0, 4)}</div>
                <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                  {wk.free.map(p => { const on = f.termin_partia === p.id && f.termin_real.includes(fmtSk(wk.start)); return (
                    <button key={p.id} type="button" onClick={() => pickWeek(wk, p)} style={{ padding: '5px 11px', borderRadius: RADIUS.full, fontSize: TYPO.sizes.sm, cursor: 'pointer', fontFamily: 'inherit', border: `1px solid ${on ? COLORS.brand : COLORS.line}`, background: on ? COLORS.brand : 'transparent', color: on ? '#fff' : COLORS.text }}>{p.name}</button>) })}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* ── SPODNÁ ČASŤ: NÁLEŽITOSTI OBHLIADKY — rovnaký štýl polí, oddelená karta ── */}
      <div style={{ background: COLORS.bg, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md, padding: SPACE.md }}>
        {/* prepínač Omietky / Poter — ako mview */}
        <div style={{ display: 'flex', gap: 8, marginBottom: SPACE.sm }}>
          {[['omietky', 'Omietky'], ['poter', 'Poter']].map(([k, l]) => (
            <button key={k} type="button" onClick={() => set('typ', k)} style={{
              flex: 1, maxWidth: 220, padding: 9, borderRadius: RADIUS.md, fontWeight: TYPO.weights.bold, fontSize: TYPO.sizes.base, cursor: 'pointer', fontFamily: 'inherit',
              border: `1px solid ${f.typ === k ? COLORS.brand : COLORS.line}`, background: f.typ === k ? COLORS.brand : '#fff', color: f.typ === k ? '#fff' : COLORS.text,
            }}>{l}</button>
          ))}
        </div>

        <Grp>Objekt</Grp>
        <FieldGrid>
          <Field label="Druh nehnuteľnosti">
            <Chips opts={OPT.druh_nehnutelnosti} val={f.druh_nehnutelnosti} onPick={v => set('druh_nehnutelnosti', v)} />
            {f.druh_nehnutelnosti === 'Iné' && <input style={{ ...inp, marginTop: 5 }} value={f.druh_popis} onChange={e => set('druh_popis', e.target.value)} placeholder="Iné — aký objekt?" />}
          </Field>
          <Field label="Stav objektu">
            <Chips opts={OPT.stav_objektu} val={f.stav_objektu} onPick={v => set('stav_objektu', v)} />
          </Field>
          {/* Murivo pri POTERI vynechane (Mirko 27.7.) — pre poter je irelevantne */}
          {!isPoter && <Field label="Murivo">
            <Chips opts={OPT.murivo} val={f.murivo} onPick={v => set('murivo', v)} />
            {f.murivo === 'Iné' && <input style={{ ...inp, marginTop: 5 }} value={f.murivo_popis} onChange={e => set('murivo_popis', e.target.value)} placeholder="Iné — aké murivo?" />}
          </Field>}
        </FieldGrid>

        {!isPoter ? (<>
          <Grp>Omietka</Grp>
          <FieldGrid>
            <Field label="Realizácia"><Chips opts={OPT.realizacia} val={f.realizacia} onPick={v => set('realizacia', v)} /></Field>
            <Field label="Druh omietky">
              <Chips opts={OPT.druh_omietky} val={f.druh_omietky} onPick={v => set('druh_omietky', v)} />
              {f.druh_omietky === 'Iné' && <input style={{ ...inp, marginTop: 5 }} value={f.omietka_popis} onChange={e => set('omietka_popis', e.target.value)} placeholder="Iné — aký druh?" />}
            </Field>
            <Field label="Výmera pôdorys (m²)"><input style={inp} type="number" value={f.vymera_podorys} onChange={e => set('vymera_podorys', e.target.value)} /></Field>
            <Field label="Výmera omietky (m²)"><input style={inp} type="number" value={f.vymera_omietky} onChange={e => set('vymera_omietky', e.target.value)} /></Field>
            <Field label="Omietanie stropov">
              <YesNo label="" val={f.stropy} onChange={v => set('stropy', v)} />
              {f.stropy && <input style={{ ...inp, marginTop: 4 }} type="number" value={f.stropy_priplatok} onChange={e => set('stropy_priplatok', e.target.value)} placeholder="cena za stropy €/m²" />}
            </Field>
            <Field label="Výstuž celoplošne (sieťka)">
              <YesNo label="" val={f.sietka} onChange={v => set('sietka', v)} />
              {f.sietka && <input style={{ ...inp, marginTop: 4 }} type="number" value={f.sietka_cena} onChange={e => set('sietka_cena', e.target.value)} placeholder="cena výstuže €/m²" />}
            </Field>
          </FieldGrid>
        </>) : (<>
          <Grp>Poter</Grp>
          <FieldGrid cols={1}>
            <Field label="Materiál">
              <Chips opts={OPT.poter_material} val={f.poter_material}
                onPick={v => { set('poter_material', v); set('poter_material_kod', '') }} />
              {/* Konkretny produkt z MIXIN katalogu (Mirko 27.7.: „ak zvolim anhydrit, daj moznosti
                  z katalogu poteru Mixinu") — zdroj = /api/poter-protokoly/meta (Poter protokol). */}
              {f.poter_material && (() => {
                const fam = f.poter_material === 'Anhydrit' ? (mixin.anhydrit || []) : (mixin.cement || [])
                if (!fam.length) return null
                return (
                  <div style={{ marginTop: 6 }}>
                    <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginBottom: 3 }}>Produkt (MIXIN katalóg — min. hrúbka nad kúrením podľa TL):</div>
                    <div style={{ display: 'flex', gap: 5, flexWrap: 'wrap' }}>
                      {fam.map(m => { const on = f.poter_material_kod === m.code; return (
                        <button key={m.code} type="button" onClick={() => set('poter_material_kod', on ? '' : m.code)}
                          title={`${m.cls} · min. ${m.min_mm} mm nad kúrením`}
                          style={{ padding: '5px 11px', borderRadius: RADIUS.full, fontSize: TYPO.sizes.sm, cursor: 'pointer', fontFamily: 'inherit',
                            border: `1px solid ${on ? COLORS.brand : COLORS.line}`, background: on ? COLORS.brand : '#fff', color: on ? '#fff' : COLORS.text }}>
                          {m.name} <span style={{ opacity: 0.75, fontSize: TYPO.sizes.xs }}>· min {m.min_mm} mm</span>
                        </button>) })}
                    </div>
                  </div>
                )
              })()}
            </Field>
          </FieldGrid>
          <div style={{ marginTop: 6 }}>
            <div style={{ fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.semibold, color: COLORS.muted, textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: 4 }}>Podlažia</div>
            {/* Vagrys + finalna vyska poteru OD VAGRYSU per podlazie (Mirko 27.7. „je to dolezite");
                druha vyska + popis = odlisna uroven napr. kupelna/dlazba. */}
            {f.poter_podlazia.length > 0 && (
              <div style={{ display: 'grid', gridTemplateColumns: '1.6fr 0.8fr 0.8fr 0.9fr 1fr auto', gap: 6, fontSize: 10.5, color: COLORS.muted, fontWeight: TYPO.weights.semibold, marginBottom: 2, textTransform: 'uppercase', letterSpacing: '0.03em' }}>
                <span>Miestnosť / podlažie</span><span>Plocha m²</span><span>Hrúbka mm</span><span>Vagrys (cm)</span><span>Fin. výška od vagrysu (cm)</span><span />
              </div>
            )}
            {f.poter_podlazia.map((p, i) => (
              <div key={i} style={{ border: `1px solid ${COLORS.lineSoft || COLORS.line}`, borderRadius: RADIUS.md, padding: 6, marginBottom: 6 }}>
                <div style={{ display: 'grid', gridTemplateColumns: '1.6fr 0.8fr 0.8fr 0.9fr 1fr auto', gap: 6, alignItems: 'center' }}>
                  <input style={inp} value={p.miestnost} onChange={e => setPodl(i, 'miestnost', e.target.value)} placeholder="Miestnosť / podlažie" />
                  <input style={inp} type="number" value={p.plocha_m2} onChange={e => setPodl(i, 'plocha_m2', e.target.value)} placeholder="m²" />
                  <input style={inp} type="number" value={p.hrubka_mm} onChange={e => setPodl(i, 'hrubka_mm', e.target.value)} placeholder="mm" />
                  <input style={inp} type="number" value={p.vagrys || ''} onChange={e => setPodl(i, 'vagrys', e.target.value)} placeholder="napr. 100" title="Vagrys — výška značky nad podlahou (cm)" />
                  <input style={inp} type="number" value={p.vyska_od_vagrysu || ''} onChange={e => setPodl(i, 'vyska_od_vagrysu', e.target.value)} placeholder="napr. -98" title="Finálna výška poteru meraná od vagrysu (cm)" />
                  <button type="button" onClick={() => delPodl(i)} style={{ border: `1px solid ${COLORS.line}`, background: '#fff', borderRadius: RADIUS.sm, cursor: 'pointer', color: COLORS.muted, padding: '4px 9px' }}>−</button>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: 6, marginTop: 5 }}>
                  <input style={inp} type="number" value={p.vyska2 || ''} onChange={e => setPodl(i, 'vyska2', e.target.value)} placeholder="Odlišná výška od vagrysu (cm)" title="Druhá finálna výška — napr. kúpeľňa / dlažba" />
                  <input style={inp} value={p.vyska2_popis || ''} onChange={e => setPodl(i, 'vyska2_popis', e.target.value)} placeholder="Kde a prečo odlišná — napr. kúpeľňa, dlažba nižšie o 12 mm" />
                </div>
              </div>
            ))}
            <BtnGhost onClick={addPodl}>+ Podlažie</BtnGhost>
          </div>
          <div style={{ marginTop: 10 }}>
            <div style={{ fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.semibold, color: COLORS.muted, textTransform: 'uppercase', letterSpacing: '0.04em' }}>Upozornenia pre zákazníka — pripravenosť podkladu</div>
            <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.nav, margin: '2px 0 4px' }}>Informuj vopred, čo bude treba pripraviť (overenie stavu rieši až protokol pri realizácii).</div>
            {POTER_CHECKLIST.map(c => (
              <label key={c.key} style={{ display: 'flex', gap: 8, alignItems: 'flex-start', padding: '4px 0', fontSize: TYPO.sizes.sm, lineHeight: 1.35 }}>
                <input type="checkbox" checked={f.poter_checklist.includes(c.key)} onChange={() => togglePC(c.key)} style={{ width: 16, height: 16, marginTop: 1, flexShrink: 0 }} />
                <span>{c.label}</span>
              </label>
            ))}
          </div>
        </>)}

        <Grp>Prípojky &amp; prístup</Grp>
        <FieldGrid>
          <Field label="Voda (potrebná tlaková)"><Chips opts={OPT.voda} val={f.voda} onPick={v => set('voda', v)} /></Field>
          {!isPoter && <Field label="Elektrika">
            <Chips opts={OPT.elektrika} val={f.elektrika} onPick={v => set('elektrika', v)} />
            {f.elektrika === 'Iné' && <input style={{ ...inp, marginTop: 5 }} value={f.elektrika_popis} onChange={e => set('elektrika_popis', e.target.value)} placeholder="Iné — popis" />}
          </Field>}
          <Field label="Prístup">
            <Chips opts={OPT.pristup} val={f.pristup} onPick={v => set('pristup', v)} />
            {f.pristup === 'Iné' && <input style={{ ...inp, marginTop: 5 }} value={f.pristup_popis} onChange={e => set('pristup_popis', e.target.value)} placeholder="Iné — popis" />}
          </Field>
          {!isPoter && <Field label="Príjazd nákladiaka s paletami">
            <YesNo label="" val={f.prijazd_nakladiak} onChange={v => set('prijazd_nakladiak', v)} />
          </Field>}
        </FieldGrid>

        {!isPoter && (<>
          <Grp>Doplnkové služby — záujem zákazníka</Grp>
          <FieldGrid>
            <Field label="Potery">
              <YesNo label="" val={!!f.sluzby.potery} onChange={v => setSluzba('potery', v)} />
              {f.sluzby.potery && <input style={{ ...inp, marginTop: 4 }} value={f.sluzby.potery_popis} onChange={e => setSluzba('potery_popis', e.target.value)} placeholder="typ / hrúbka" />}
            </Field>
            <Field label="Zateplenie"><YesNo label="" val={!!f.sluzby.zateplenie} onChange={v => setSluzba('zateplenie', v)} /></Field>
            <Field label="Maľovanie"><YesNo label="" val={!!f.sluzby.malovanie} onChange={v => setSluzba('malovanie', v)} /></Field>
            <Field label="Iné">
              <YesNo label="" val={!!f.sluzby.ine} onChange={v => setSluzba('ine', v)} />
              {f.sluzby.ine && <input style={{ ...inp, marginTop: 4 }} value={f.sluzby.ine_popis} onChange={e => setSluzba('ine_popis', e.target.value)} placeholder="popis" />}
            </Field>
          </FieldGrid>
        </>)}

        <Grp>Cena</Grp>
        <FieldGrid>
          {!isPoter ? (<>
            <Field label="Cena €/m²"><input style={inp} type="number" value={f.cena_m2} onChange={e => set('cena_m2', e.target.value)} /></Field>
            <Field label="Materiál 15 mm kg/m²"><input style={inp} type="number" value={f.material_kg} onChange={e => set('material_kg', e.target.value)} /></Field>
          </>) : (<>
            <Field label="Cena materiálu (€)"><input style={inp} type="number" value={f.cena_materialu} onChange={e => set('cena_materialu', e.target.value)} /></Field>
            <Field label="Cena práce (€/m²)"><input style={inp} type="number" value={f.cena_prace} onChange={e => set('cena_prace', e.target.value)} /></Field>
            <Field label="Príplatok palivový / doprava (€)"><input style={inp} type="number" value={f.priplatok_palivo} onChange={e => set('priplatok_palivo', e.target.value)} /></Field>
          </>)}
        </FieldGrid>

        <Grp>Informuj zákazníka pred dohodou</Grp>
        <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.nav, marginBottom: 4 }}>Zaškrtni, čo si zákazníkovi povedal.</div>
        {(isPoter ? POTER_INFORMUJ : INFORMUJ).map(t => (
          <label key={t} style={{ display: 'flex', gap: 8, alignItems: 'flex-start', padding: '4px 0', fontSize: TYPO.sizes.sm, lineHeight: 1.35 }}>
            <input type="checkbox" checked={f.informoval.includes(t)} onChange={() => toggleInf(t)} style={{ width: 16, height: 16, marginTop: 1, flexShrink: 0 }} />
            <span>{t}</span>
          </label>
        ))}

        <Grp>Záver</Grp>
        <Field label="Poznámka">
          <textarea style={{ ...inp, resize: 'vertical', minHeight: 56 }} value={f.poznamka} onChange={e => set('poznamka', e.target.value)} />
        </Field>
        <div style={{ marginTop: 8, fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.semibold, color: COLORS.muted, textTransform: 'uppercase', letterSpacing: '0.04em' }}>Fotky ({f.foto.length})</div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginTop: 5, alignItems: 'center' }}>
          {f.foto.map((u, i) => (
            <span key={i} style={{ position: 'relative', display: 'inline-block' }}>
              <a href={u} target="_blank" rel="noreferrer"><img src={u} alt="" style={{ width: 96, height: 70, objectFit: 'cover', borderRadius: 6, border: `1px solid ${COLORS.line}` }} /></a>
              <button type="button" onClick={() => set('foto', f.foto.filter((_, x) => x !== i))} title="Odobrať fotku"
                style={{ position: 'absolute', top: -6, right: -6, width: 20, height: 20, borderRadius: 10, border: `1px solid ${COLORS.line}`, background: '#fff', cursor: 'pointer', fontSize: 11, lineHeight: '17px', color: COLORS.muted }}>✕</button>
            </span>
          ))}
          <label style={{ width: 96, height: 70, border: `1px dashed ${COLORS.brand}`, borderRadius: 6, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: COLORS.brand, fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.bold }}>
            + Pridať
            <input type="file" accept="image/*" multiple style={{ display: 'none' }}
              onChange={async e => { const files = Array.from(e.target.files || []); e.target.value = ''; await uploadFoto(files) }} />
          </label>
        </div>
        {record.signed_name && <div style={{ marginTop: 8, fontSize: TYPO.sizes.sm, color: COLORS.muted }}>Podpísané zákazníkom: <strong style={{ color: COLORS.text }}>{record.signed_name}</strong>{record.signed_at ? ' · ' + record.signed_at : ''} (podpis sa zbiera v mobilnej obhliadke)</div>}
      </div>

      {/* VYSKY_V1: Meranie výšky podlahy — ten istý register ako zákazka (cil 'obhliadka'); ukáže sa len pri obhliadke s potermi alebo s meraním */}
      {record && record.id && <VyskyStavba cil="obhliadka" id={record.id} />}

      {/* ── ULOŽIŤ ── */}
      <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
        <BtnAdd onClick={save} disabled={saving || !dirty}>{saving ? 'Ukladám…' : '✓ Uložiť obhliadku'}</BtnAdd>
        {dirty && <BtnGhost onClick={() => { setF(fromRecord(record)); setDirty(false) }}>Zahodiť zmeny</BtnGhost>}
        {!dirty && <span style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted }}>Žiadne neuložené zmeny</span>}
      </div>

      <NoviCustomerDialog open={novyOpen} prefillName={novyPrefill}
        onClose={() => { setNovyOpen(false); setNovyPrefill('') }}
        onCreated={c => { setCustomers(prev => [...prev, c]); pickCustomer(c.id); setNovyOpen(false); setNovyPrefill('') }} />
    </div>
  )
}
